import type { ReactNode } from 'react'
import { Button, SearchInput } from '../../shared/ui'
import { getStages } from '../../lib/stages'

/**
 * Search box + main stage filter + toggle for advanced filters +
 * action buttons (Add Contact, Import, Export, Saved Views). Add/Import/Views
 * all delegate to existing legacy window functions for this PR;
 * the bar UI itself is React.
 */

interface Props {
  search: string
  stage: string
  onSearchChange: (v: string) => void
  onStageChange: (v: string) => void
  advancedOpen: boolean
  onToggleAdvanced: () => void
  /** Extra controls rendered after the filter toggle (saved views). */
  extra?: ReactNode
}

export function ContactsToolbar({
  search,
  stage,
  onSearchChange,
  onStageChange,
  advancedOpen,
  onToggleAdvanced,
  extra,
}: Props) {
  const stages = getStages()

  const callLegacy = (fn: 'openAddContact' | 'openImport') => {
    const f = (window as unknown as Record<string, undefined | (() => void)>)[fn]
    f?.()
  }
  // CSV export stays in the legacy host (exportContacts); it applies the
  // same search + stage filter the table shows.
  const exportCsv = () => {
    const f = (window as unknown as Record<string, undefined | ((o: object) => void)>)
      .exportContacts
    f?.({ search, stage })
  }

  return (
    <div className="toolbar">
      <SearchInput
        value={search}
        onChange={onSearchChange}
        placeholder="Search name, company, title, email, phone…"
      />

      <select
        className="filter-select"
        id="c-stage"
        value={stage}
        onChange={(e) => onStageChange(e.target.value)}
      >
        <option value="">All Stages</option>
        {stages.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
        <option value="__nodomain">⚠ No Domain</option>
        <option value="__noemail">✉ No Email</option>
        <option value="__stale">⏱ Stale</option>
      </select>

      <Button variant="secondary" onClick={onToggleAdvanced} aria-expanded={advancedOpen}>
        {advancedOpen ? 'Hide Filters' : 'Filters'}
      </Button>

      {extra}

      <Button variant="secondary" onClick={() => callLegacy('openImport')}>
        Import
      </Button>
      <Button variant="secondary" onClick={exportCsv}>
        Export
      </Button>
      <Button onClick={() => callLegacy('openAddContact')}>+ Contact</Button>
    </div>
  )
}
